var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab__box"},_vm._l((_vm.historyList),function(item,index){return _c('el-tag',{key:index,staticClass:"tag__item",attrs:{"closable":"","size":"mini","type":item.type},on:{"close":function($event){_vm.handleClose(index)},"click":function($event){_vm.goPage(item.name,item.params)}}},[_vm._v(_vm._s(item.title))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b296c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/history.vue
// module id = null
// module chunks = 